module.exports = __webpack_public_path__ + "static/media/19ESCAP47.29abc74a.jpg";